import * as React from 'react'
import { Flex } from '@radix-ui/themes'
import { yenKanji } from '@/lib/price'
import { FlowerCollectionProduct } from '~/api-client/data-contracts'
import { styles } from './styles.css'

type Props = {
  inBulkOrderble: FlowerCollectionProduct | null
}

function discountedPrice(price: number): number {
  return Math.round(price * 0.8)
}

function backcalcTax(price: number): [number, number] {
  const t =  Math.round(price / 11.0)

  return [t, price - t]
}

function rows({ inBulkOrderble }): Record<string, string>[] {
  if (inBulkOrderble) {
    const { name, price } = inBulkOrderble.attributes
    const [tax, priceWithoutTax] = backcalcTax(discountedPrice(price))

    return [
      { label: '季節のおまかせブーケ（1配送分）', price: yenKanji(2700) },
      { label: name, price: yenKanji(priceWithoutTax) },
      { label: 'お花の栄養剤（5回分）', price: yenKanji(0) },
      { label: '配送料', price: yenKanji(0) },
      { label: '消費税', price: yenKanji(270 + tax) },
    ]
  } else {
    return [
      { label: '季節のおまかせブーケ（1配送分）', price: yenKanji(2700) },
      { label: 'お花の栄養剤（5回分）', price: yenKanji(0) },
      { label: '配送料', price: yenKanji(0) },
      { label: '消費税', price: yenKanji(270) },
    ]
  }
}

function total({ inBulkOrderble }): string {
  if (inBulkOrderble) {
    return yenKanji(2700 + 270 + inBulkOrderble.attributes.bulk_discounted_price)
  } else {
    return yenKanji(2700 + 270)
  }
}

export const PriceTable: React.FC<Props> = ({ inBulkOrderble }) => {
  return (
    <Flex direction="column" role="table" gap="16px" width="100%">
      {rows({ inBulkOrderble }).map((row) => (
        <Flex direction="row" justify="between" align="center" key={row.label}>
          <span className={styles.cell}>{row.label}</span>
          <span className={styles.cell}>{row.price}</span>
        </Flex>
      ))}
      <hr className={styles.divider} />
      <Flex direction="row" justify="between" align="center">
        <span className={styles.totalCell}>合計</span>
        <span className={styles.totalCell}>{total({ inBulkOrderble })}</span>
      </Flex>
    </Flex>
  )
}
